module.exports = __webpack_public_path__ + "static/media/banner_two.850b29a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_two.svg
// module id = 2091
// module chunks = 7